const t = "submitBtn_ZOGrV", s = "submitBtn__disabled_F3iXd", _ = "submitBtn__apple_IjOri", i = "submitBtn__google_sAkaf", n = {
  submitBtn: t,
  submitBtn__disabled: s,
  submitBtn__apple: _,
  submitBtn__google: i
};
export {
  n as default,
  t as submitBtn,
  _ as submitBtn__apple,
  s as submitBtn__disabled,
  i as submitBtn__google
};
//# sourceMappingURL=paymentButton.module.scss.js.map
